// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1C3q5","header":"Messages_header__ljF0-"};